export const useHelpers = () => {

    const tieneDescendientesAsignados = (hijos) =>
        hijos.some(h => h.is_assigned || (h.hijos?.length > 0 && tieneDescendientesAsignados(h.hijos)))

    const extractPermissionsSelected = (items, selected = []) => {
        items.forEach((item) => {
            const tieneHijos = item.hijos && item.hijos.length > 0

            if (item.is_assigned) {
                selected.push(item)
            } else if (tieneHijos && tieneDescendientesAsignados(item.hijos)) {
                // Padre no asignado directamente pero tiene descendientes asignados:
                // se incluye para que el backend no lo elimine de la BD
                selected.push(item)
            }

            if (tieneHijos) {
                extractPermissionsSelected(item.hijos, selected)
            }
        })
        return selected
    }

    return Object.freeze({
        extractPermissionsSelected,
    })
}